const DOM = {};

const cacheDOM = () => {
    DOM.boxes = document.querySelectorAll('.share-box');
};

const toggleShareBox = (shareWrapper) => {
    const shareBox = shareWrapper.parentElement;
    shareBox.classList.toggle('share-box--active');
};

const handleClick = (e) => {
    let { target } = e;
    if (e.target.classList.contains('uil')) {
        target = e.target.parentElement;
    }
    toggleShareBox(target);
};

const bindEvents = () => {
    DOM.boxes.forEach((wrapper) => {
        wrapper.addEventListener('click', handleClick);
    });
};

const init = () => {
    cacheDOM();
    if (DOM.boxes.length > 0) {
        bindEvents();
    }
};

const share = { init };
export default share;
